<h2 mat-dialog-title class="dialog-title headline-small-emphasized">{{ title }}</h2>

<mat-dialog-content>
  <span class="body-medium">{{ message }}</span>
</mat-dialog-content>

<mat-dialog-actions class="confirm-actions">
  <button matButton type="button" [mat-dialog-close]="false">Annulla</button>

  <button
    matButton="filled"
    type="button"
    [class.destructive]="destructive"
    [mat-dialog-close]="true"
  >
    {{ destructive ? 'Elimina' : 'Conferma' }}
  </button>
</mat-dialog-actions>
